// extracted by mini-css-extract-plugin
module.exports = {"anchor":"_1Y9pBzXvcIhof5VLoIJhjp","approach":"_302seDnD3OIlrJkeRcPDph","title":"_3yLGpKicPvC64ZlfJREi5s","content":"_1ltcG1lOZvAnUS--V-3Kgk","button":"_1QGf3kxOG34UtHPY_MUSch"};